import { DATAFEED_API_HOSTNAME, NEW_HOST_URL, PUBLISHER_URL } from "../../config/envConfig";
import { fetch } from "../../utils";

export const loginUser = (credentials) =>
  fetch(`${NEW_HOST_URL}/login`, {
    method: "POST",
    mode: "cors",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const opsloginUser = (credentials) =>
  fetch(`${NEW_HOST_URL}/opslogin`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const otpAuthentication = (payload) =>
  fetch(`${NEW_HOST_URL}/otp-verification`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const me = () =>
  fetch(`${NEW_HOST_URL}/me`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getUserDetails = (data) =>
  fetch(`${NEW_HOST_URL}/get_invite_user/${localStorage.getItem("__uid")}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getAppliedFilter = (data) =>
  fetch(`${NEW_HOST_URL}/filter-by-sports?userId=${localStorage.getItem("__uid")}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getFilterUser = ({ userId }, data) =>
  fetch(`${NEW_HOST_URL}/get_invite_user/${userId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const deleteUsers = (userId) =>
  fetch(`${NEW_HOST_URL}/delete_invite_user/${userId}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
    // body: JSON.stringify(credentials),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const addUsers = (data) =>
  fetch(`${NEW_HOST_URL}/create-user`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const updateUsers = (credentials) =>
  fetch(`${NEW_HOST_URL}/update_permission`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const updateUser = (payload) => {
  fetch(`${NEW_HOST_URL}/update-user`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const createStorage = (data) =>
  fetch(`${NEW_HOST_URL}/storage-list-create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const createStorageAdmin = (data) =>
  fetch(`${NEW_HOST_URL}/accounts/storages/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getStorage = (data) =>
  fetch(`${NEW_HOST_URL}/accounts/storage/get`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getStorageList = (data) =>
  fetch(`${NEW_HOST_URL}/get-storage-list`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getUserOfStorage = (data) =>
  fetch(`${NEW_HOST_URL}/get-assigned-user-of-storage`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const editStorageDetails = (data) =>
  fetch(`${NEW_HOST_URL}/storage-list-edit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const editStorageDetailsAdmin = (data) =>
  fetch(`${NEW_HOST_URL}/accounts/storages/edit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const deleteStorage = (data) =>
  fetch(`${NEW_HOST_URL}/delete-storage-list`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const deleteStorageAdmin = (data) =>
  fetch(`${NEW_HOST_URL}/accounts/storages/delete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const createAccount = (data) =>
  fetch(`${NEW_HOST_URL}/signup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const createUserProfile = (data) =>
  fetch(`${NEW_HOST_URL}/create/social-media-profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
export const editUserProfile = (data) =>
  fetch(`${NEW_HOST_URL}/edit/social-media-profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
export const deleteUserProfile = (data) =>
  fetch(`${NEW_HOST_URL}/delete/social-media-profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
export const addSocialMediaPlatforms = (data) =>
  fetch(`${PUBLISHER_URL}/api/v1/social_media.generate_profile_jwt`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getUser = ({ id }) =>
  fetch(`${NEW_HOST_URL}/get-user-by-id/${id}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getPublishHistory = (data) =>
  fetch(`${NEW_HOST_URL}/api/v1/third-party/get-publish-data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const addPublishNotification = (data) =>
  fetch(`${NEW_HOST_URL}/api/v1/third-party/add-publish-data`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
export const fetchLoggerDetails = ({ limit, activePage, ..._data }) => {
  return fetch(`${NEW_HOST_URL}/fetch-loggers?limit=${limit}&page_no=${activePage}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const fetchClientData = (_payload) => {
  return fetch(`${NEW_HOST_URL}/org/opsDashboard`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .catch((err) => {
      throw err;
    });
};

export const updateLoggerDetails = (data) => {
  return fetch(`${NEW_HOST_URL}/update-logger`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getClientSetting = (data) => {
  return fetch(`${NEW_HOST_URL}/get-client-settings/${data.entityId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    // body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const updateClientSetting = (data) => {
  return fetch(`${NEW_HOST_URL}/client-settings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

// To get the status of added streams by Admin and its users
export const getOrganizationProcessingLimit = (data) => {
  return fetch(`${NEW_HOST_URL}/processing-stream/get/${data.entityId}`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

// function for updating token for login limit functionality
export const updateToken = (data) => {
  return fetch(`${NEW_HOST_URL}/update_token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

// function for removing token for login limit functionality
export const removeIp = (data) => {
  return fetch(`${NEW_HOST_URL}/remove_ip`, {
    method: "POST",
    mode: "cors",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const clientWebHookPublish = (data) => {
  return fetch(`${NEW_HOST_URL}/client-cms-publish`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getPackages = (data) => {
  return fetch(`${NEW_HOST_URL}/package_name`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getFolder = (data) => {
  return fetch(`${NEW_HOST_URL}/folder_name`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
// To get users by userIds

export const getUsersByUserIds = ({ ...data }) => {
  return fetch(`${NEW_HOST_URL}/get-users-by-ids`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

//storage-validation
export const storageValidation = (data) => {
  return fetch(`${NEW_HOST_URL}/validate_storage`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const updateStorageMultipleFolderPath = ({ ...data }) => {
  return fetch(`${NEW_HOST_URL}/storage-folder-path-update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

// To get access control of user according to role

export const fetchAccessControl = (role) => {
  return fetch(`${NEW_HOST_URL}/get-role/${role}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const fetchXmlFormats = () => {
  return fetch(`${NEW_HOST_URL}/get-xml-formats`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const updateXmlDetails = (data) => {
  return fetch(`${NEW_HOST_URL}/update_xml_details`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

//Process List
export const getProcessList = ({ ...data }) => {
  return fetch(`${NEW_HOST_URL}/queue_process_list`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

//Cancel Process
export const cancelProcess = (data) => {
  return fetch(`${NEW_HOST_URL}/update_firestore_process/${data?.processId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSSOUrl = (data) => {
  return fetch(`${NEW_HOST_URL}/sso/get_sign_url`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const importS3GlacierStreams = (data) => {
  return fetch(`${NEW_HOST_URL}/import_glacier_streams`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getDownloadVideosCSV = (data) => {
  return fetch(`${NEW_HOST_URL}/youtube-downloadVideos`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
    body: data,
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getYoutubeDownloadVideosData = (data) => {
  return fetch(`${NEW_HOST_URL}/youTubeVideosData`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const createIllustoAccount = (data) => {
  return fetch(`${NEW_HOST_URL}/create-illusto-account`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const resyncIllustoResource = (data) => {
  fetch(`${NEW_HOST_URL}/resource-resync`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getFeatureList = ({ id }) => {
  return fetch(`${NEW_HOST_URL}/feature/list/${id}`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrganization = ({ id }) => {
  return fetch(`${NEW_HOST_URL}/organization/${id}`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrganizationConfigCategory = ({ organizationId }) => {
  return fetch(`${NEW_HOST_URL}/organization-config/${organizationId}`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllDatafeedConfigsForOrganization = ({ organizationId }) => {
  return fetch(
    `${DATAFEED_API_HOSTNAME}/api/v2/datafeed/all-datafeed-configs-for-organization?organizationId=${organizationId}`,
    {
      method: "GET",
      headers: {
        Authorization: localStorage.getItem("authToken"),
        "Content-Type": "application/json",
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getWorkspaceConfigCategory = ({ workspaceId }) => {
  return fetch(`${NEW_HOST_URL}/workspace-config/${workspaceId}`, {
    method: "GET",
    headers: {
      Authorization: localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateOrganization = (data) => {
  return fetch(`${NEW_HOST_URL}/organization/update/${data?.id}`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("authToken"),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getUsersByOrganization = (data) => {
  return fetch(`${NEW_HOST_URL}/organizaton/user/${data.id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrganizationAddUser = (data) => {
  return fetch(`${NEW_HOST_URL}/organization/add-user`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrganizationListById = (payload) => {
  return fetch(`${NEW_HOST_URL}/organization/get`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrganizationsByIds = (payload) => {
  return fetch(`${NEW_HOST_URL}/get-organization-by-ids`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const getUserAnalytics = () =>
  fetch(`${NEW_HOST_URL}/user/analytics`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getAssignedStorageOrganization = (data) =>
  fetch(`${NEW_HOST_URL}/storage/assigned-organization`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getOrganizationStorage = (data) =>
  fetch(`${NEW_HOST_URL}/storage/get`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const getUsers = async (data) => {
  //fromDate=${data?.fromDate}&toDate=${data?.toDate}
  return fetch(
    `${NEW_HOST_URL}/users?page=${data?.page}&pageSize=${data?.pageSize}&searchQuery=${data?.search}&role=${data?.role}&allOpsRoles=${data?.allOpsRoles || false}&roleType=${data?.roleType}&fromDate=${data?.fromDate || ""}&toDate=${data?.toDate || ""}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const userUpdate = async (data) => {
  return fetch(`${NEW_HOST_URL}/user/${data?.userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      name: data?.name,
      photo: data?.photo,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const deleteUser = async (data) => {
  return fetch(`${NEW_HOST_URL}/user/${data?.userId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getUserOrganizations = async (data) => {
  return fetch(`${NEW_HOST_URL}/user/${data?.userId}/organizations`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getUserWorkspaces = async (data) => {
  return fetch(`${NEW_HOST_URL}/user/${data?.userId}/workspaces`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const validateUserAuthentication = (data) =>
  fetch(`${NEW_HOST_URL}/validate-user`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const syncTv2PlayerData = (data) => {
  return fetch(`${NEW_HOST_URL}/tv2_player_mapping`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const resetUserPassword = (data) => {
  return fetch(`${NEW_HOST_URL}/user/reset-password`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};
export const getSocialProfiles = (data) => {
  return fetch(`${PUBLISHER_URL}/api/v1/social_media.get_profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
};

export const createSocialProfile = (data) =>
  fetch(`${PUBLISHER_URL}/api/v1/social_media.create_profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
export const updateSocialProfile = (data) =>
  fetch(`${PUBLISHER_URL}/api/v1/social_media.update_profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
export const deleteSocialProfile = (data) =>
  fetch(`${PUBLISHER_URL}/api/v1/social_media.delete_profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });

export const registerGCPUser = (data) =>
  fetch(`${NEW_HOST_URL}/management/gcp-marketplace/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((error) => {
      throw error;
    });
